import * as type from '../actions/types';

const initialState = {
    notification_count: "",
    loading: false,
    error: null,
}

export default function getNotificationCount(state = initialState, action) {
    switch (action.type) {
        case type.GET_NOTIFICATION_COUNT_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_NOTIFICATION_COUNT_SUCCESS:
            return {
                ...state,
                loading: false,
                notification_count: action.data
            }
        case type.GET_NOTIFICATION_COUNT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}